import DownloadModal from '@/components/downloadModal';
import { Event, Page } from '@/config/track-config';
import { Button, TextLink, Tooltip } from '@bfe/moly';
import { useFm, useScreenType, useVisible } from '@web3/base-hooks';
import { scTrack } from '@web3/base-tracking';
import {
  appPath,
  BybitWalletChromeExtensionLink,
  openLink,
} from '@web3/base-utils';
import { createWalletModalStore, useConnectWalletModal } from '@web3fe/infra';
import cls from 'classnames';
import { FC } from 'react';

import 'swiper/css';
import 'swiper/css/pagination';

import styles from './index.module.scss';

export const UnConnected: FC = () => {
  const fm = useFm();
  const modalState = useVisible();
  const { isMobile } = useScreenType();

  // 链接钱包弹窗
  const connectModalState = useConnectWalletModal();

  const handleConnect = () => {
    connectModalState.show();
  };

  const openExtension = () => {
    scTrack(Event.Web3UserClick, {
      page_name: Page.Home,
      area: 'Banner',
      button_name: 'ChromeExtension',
    });
    if (isMobile) {
      openLink(BybitWalletChromeExtensionLink);
      return;
    }
    window.open(BybitWalletChromeExtensionLink);
  };

  const actionDom = (
    <Button
      variant="primary"
      size={isMobile ? 'small' : 'middle'}
      className={styles.connectBtn}
      onClick={() => {
        scTrack(Event.Web3UserClick, {
          page_name: Page.Home,
          area: 'Banner',
          button_name: 'CreateWallet',
        });
        handleConnect();
      }}
    >
      {fm('connect_wallet')}
    </Button>
  );

  return (
    <>
      <div className={styles.left}>
        <div className={styles.title}>{fm('portalToWeb3Easy')}</div>
        <div className={cls(styles.action, 'pc')}>{actionDom}</div>
        <div className={styles.download}>
          <div className={styles.row}>
            <Tooltip
              title={<img src={`${appPath}/png/home/appQR.png`} alt="img" />}
              placement="bottom"
              onOpenChange={(isOpen) => {
                if (isOpen) {
                  scTrack(Event.Web3UserClick, {
                    page_name: Page.Home,
                    area: 'Banner',
                    button_name: 'BybitApp',
                  });
                }
              }}
            >
              <div className={styles.card}>
                <img
                  className={styles.icon}
                  alt="img"
                  src="https://s1.bycsi.com/bybit/deadpool/image-a004dca8ab12401a90943e3c9b45bcba.svg"
                />
                <div className={styles.content}>
                  <div className={styles.title}>{fm('download')}</div>
                  <div className={styles.strong}>{fm('bybit_app')}</div>
                </div>
              </div>
            </Tooltip>
            <div className={styles.card} onClick={openExtension}>
              <img
                className={styles.icon}
                alt="img"
                src="https://s1.bycsi.com/bybit/deadpool/image-a2afb76ae2d64a42893c13c3bab3ae40.svg"
              />
              <div className={styles.content}>
                <div className={styles.title}>{fm('download')}</div>
                <div className={styles.strong}>{fm('chromeExtension')}</div>
              </div>
            </div>
          </div>
          <div className={styles.row}>
            <TextLink
              variant="secondary"
              className={styles.action}
              onClick={() => {
                scTrack(Event.Web3UserClick, {
                  page_name: Page.Home,
                  area: 'Banner',
                  button_name: 'More',
                });
                modalState.open();
              }}
              opensWindow
            >
              {' '}
              {fm('moreDownloadOptions')}
            </TextLink>
          </div>
        </div>
      </div>
      <DownloadModal
        visible={modalState.visible}
        onClose={() => modalState.close()}
      />
    </>
  );
};
